var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.59999 1.875C5.44503 1.875 2.88535 4.39453 2.88535 7.5C2.88535 10.6055 5.44503 13.125 8.59999 13.125C9.1268 13.125 9.55243 13.5439 9.55243 14.0625C9.55243 14.5811 9.1268 15 8.59999 15C4.39139 15 0.980469 11.6426 0.980469 7.5C0.980469 3.35742 4.39139 0 8.59999 0C12.8086 0 16.2195 3.35742 16.2195 7.5V8.4375C16.2195 9.99023 14.9396 11.25 13.3622 11.25C12.4901 11.25 11.7073 10.8633 11.1835 10.2568C10.5049 10.8721 9.59708 11.25 8.59999 11.25C6.49569 11.25 4.79023 9.57129 4.79023 7.5C4.79023 5.42871 6.49569 3.75 8.59999 3.75C9.4304 3.75 10.1983 4.01074 10.8233 4.45605C10.993 4.30957 11.2133 4.21875 11.4573 4.21875C11.9842 4.21875 12.4098 4.6377 12.4098 5.15625V7.5V8.4375C12.4098 8.95605 12.8353 9.375 13.3622 9.375C13.8891 9.375 14.3146 8.95605 14.3146 8.4375V7.5C14.3146 4.39453 11.755 1.875 8.59999 1.875ZM10.5049 7.5C10.5049 6.46582 9.65065 5.625 8.59999 5.625C7.54933 5.625 6.69511 6.46582 6.69511 7.5C6.69511 8.53418 7.54933 9.375 8.59999 9.375C9.65065 9.375 10.5049 8.53418 10.5049 7.5Z",
    fill: "#495057"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAt);
export default __webpack_public_path__ + "static/media/at.7ffb46956c12498fc819e229b916b898.svg";
export { ForwardRef as ReactComponent };